import { Installation } from "../Installation";
import { MachineStatus } from "./MachineStatus";
import { AgentInfo } from "../agent/AgentInfo";
import { MaintenanceStatusEnum } from "./MaintenanceStatusEnum";

export class InstallationStatus extends Installation {
    /** Lista di machine status, informazioni specifiche sullo stato di ogni macchina */
    statusMachines: MachineStatus[] = [];

    /** Informazioni sull'agent */
    agentInfo: AgentInfo = null;

    /** Stato della manutenzione calcolato sulla base dello stato di manutenzione delle singole macchine */
    maintenanceStatus: MaintenanceStatusEnum = MaintenanceStatusEnum.Regular;

    /** Data di prossima manutenzione relativamente all'installazione: corrisponde alla data di prossima manutenzione più piccola tra tutte le macchine*/
    nextMaintenance: Date;

    constructor() {
        super();
    }

    public parse(obj: any) {
        super.parse(obj);

        if (obj.StatusMachines && obj.StatusMachines.length > 0) {
            obj.StatusMachines.forEach((e) => {
                var ms: MachineStatus = new MachineStatus();
                ms.parse(e);
                this.statusMachines.push(ms);
            });
        }

        if (obj.AgentInfo) {
            this.agentInfo = new AgentInfo();
            this.agentInfo.parse(obj.AgentInfo);
        }

        if (obj.MaintenanceStatus != null && Object.values(MaintenanceStatusEnum).includes(obj.MaintenanceStatus)) this.maintenanceStatus = obj.MaintenanceStatus;
        if (obj.NextMaintenance != null) this.nextMaintenance = obj.NextMaintenance;
    }
}
